module.exports = "/assets/39612a5016a4385b2b54ff7d76263a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-details-flight/assets/touchdown.png
// module id = 3660
// module chunks = 0